//import { CdkTableModule } from '@angular/cdk/table';
import { Injectable, NgModule } from "@angular/core";

import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatSortModule } from "@angular/material/sort";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, NativeDateAdapter } from "@angular/material/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatChipsModule } from "@angular/material/chips";
import { MatTabsModule } from "@angular/material/tabs";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatRadioModule } from "@angular/material/radio";
import { MatRippleModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import {TextFieldModule} from '@angular/cdk/text-field';
import { MatTreeModule } from "@angular/material/tree";
import {MatSliderModule} from '@angular/material/slider';

import {
  DateAdapter,
  NativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
} from "@angular/material/tooltip";
import { DatePipe } from "@angular/common";
import { MatBadgeModule } from "@angular/material/badge";

const modules = [
  MatButtonModule,
  MatMenuModule,
  MatToolbarModule,
  MatIconModule,
  MatCardModule,
  MatTableModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatSortModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatExpansionModule,
  MatGridListModule,
  MatListModule,
  MatChipsModule,
  MatTabsModule,
  MatRadioModule,
  MatDialogModule,
  MatProgressBarModule,
  MatRippleModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatPaginatorModule,
  MatAutocompleteModule,
  MatSlideToggleModule,
  ScrollingModule,
  MatButtonToggleModule,
  TextFieldModule,
  MatBadgeModule,
  MatTreeModule,
  MatSliderModule
  /*BrowserModule,
  BrowserAnimationsModule,
  FormsModule,
  ReactiveFormsModule,
  MatAutocompleteModule,
  MatSlideToggleModule,
  ScrollingModule,
  MatButtonToggleModule,
MatBadgeModule,
MatBottomSheetModule,
MatButtonModule,
MatButtonToggleModule,
MatDialogModule,
MatDividerModule,
MatIconModule,

MatPaginatorModule,
MatAutocompleteModule,
ScrollingModule,
MatButtonToggleModule,
MatProgressBarModule,
MatRippleModule,
MatProgressSpinnerModule,
MatRippleModule,
MatSelectModule,
MatSidenavModule,
MatSliderModule,
MatSlideToggleModule,
MatSnackBarModule,
MatStepperModule,
MatTableModule,
MatToolbarModule,
MatTooltipModule,
MatSnackBarModule,
MatTreeModule,*/
];

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 0,
  touchendHideDelay: 0,
  disableTooltipInteractivity: true,
};
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: any): string {
    return new DatePipe("en-US").transform(date, "d MMM yyyy");
  }
}
@NgModule({
  imports: [...modules, NativeDateModule],
  exports: [...modules],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
  ],
})
export class MaterialModule {}
